var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1627 4.6298L14.1627 4.62981C14.2498 4.71687 14.3188 4.82023 14.366 4.93398C14.4131 5.04774 14.4374 5.16967 14.4374 5.2928C14.4374 5.41593 14.4131 5.53786 14.366 5.65161C14.3188 5.76537 14.2498 5.86873 14.1627 5.95579L14.2069 5.99999L14.1627 5.95579L6.45581 13.6627L6.45564 13.6628C6.36895 13.7502 6.26575 13.8195 6.15205 13.8667C6.03835 13.9138 5.91642 13.9379 5.79333 13.9375H5.79313H3.00001C2.75136 13.9375 2.51291 13.8387 2.33709 13.6629C2.16128 13.4871 2.06251 13.2486 2.06251 13L2.06251 10.2069L2.0625 10.2067C2.06211 10.0836 2.08619 9.96164 2.13334 9.84794C2.18049 9.73424 2.24977 9.63104 2.33715 9.54436L2.33733 9.54418L10.0442 1.83668L10.0017 1.79417L10.0442 1.83667C10.1313 1.7496 10.2346 1.68052 10.3484 1.6334C10.4621 1.58627 10.5841 1.56201 10.7072 1.56201C10.8303 1.56201 10.9523 1.58627 11.066 1.6334C11.1798 1.68052 11.2831 1.7496 11.3702 1.83667L14.1627 4.6298ZM5.79313 13.0625H5.81902L5.83732 13.0442L11.3373 7.54418L11.3815 7.49999L11.3373 7.45579L8.5442 4.66267L8.50001 4.61847L8.45581 4.66267L2.95581 10.1627L2.93751 10.181V10.2069V13V13.0625H3.00001H5.79313ZM11.9558 6.83668L12 6.88087L12.0442 6.83668L13.5442 5.33668L13.5884 5.29248L13.5442 5.24829L10.7511 2.45579L10.7069 2.4116L10.6627 2.45579L9.16269 3.95579L9.11849 3.99999L9.16269 4.04418L11.9558 6.83668Z",
    fill: "#343330",
    stroke: "#393939",
    strokeWidth: 0.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSimple);
export default __webpack_public_path__ + "static/media/PencilSimple.11a636f56125352c6e5b97526650adf5.svg";
export { ForwardRef as ReactComponent };